import styled, { css } from 'styled-components';
import { FOOTER_HEIGHT, HEADER_HEIGHT } from 'consts/UI';

const stylesWithoutIndents = css`
  width: 100%;
`;

const stylesWithIndents = css`
  width: 100%;
  padding: 64px 80px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 64px 147px;
  }

  @media (min-width: 1920px) {
    padding: 64px 240px;
  }
`;

export const Main = styled.main`
  z-index: 9;
  display: flex;
  flex-direction: column;
  text-align: left;
  box-sizing: border-box;
  min-height: calc(100vh - ${HEADER_HEIGHT}px - ${FOOTER_HEIGHT}px);

  ${({ $indented }) => {
    if ($indented) return stylesWithIndents;

    return stylesWithoutIndents;
  }}
`;
